import {ModuleWithProviders, NgModule} from '@angular/core';
import {Auth0ConfigProvider, AuthOptionsProvider} from './providers/auth0';

@NgModule({
	imports: [],
	exports: [],
	declarations: [],
	providers: [],
})
export class Auth0WrapperModule {
	static forRoot():ModuleWithProviders {
		return {
			ngModule: Auth0WrapperModule,
			providers: [
				Auth0ConfigProvider,
				AuthOptionsProvider,
			]
		};
	}
}
